import authorize from './authorize';

export default {
  authorize,
};



// WEBPACK FOOTER //
// ./src/app/services/tripletex/index.js